import React from 'react';
import ReactDOM from 'react-dom/client';
import WhatsAppDashboard from './dashboard';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<WhatsAppDashboard />);